const IndividualDevelopmentProjects = [
  {
    id: "project-1",
    title: "Appreciative Inquiry: The Power of Gratitude x Selling It Smart: What Makes a Winning Pitch x Journalistic Writing",
    thumbnail: "/projects/Individual-Development/Appreciative-Inquiry-The-Power-Of-Gratitude/power-of-gratitude1.jpg",
    contentPath: "/project-content/PowerOfGratitudexSellItSmartxJournalisticWriting.md",
    description: "This intensive, multi-disciplinary training session brings together three core pillars of professional impact: Appreciative Inquiry, Strategic Pitching, and Journalistic Writing.",
    division: "individual-development",
    IsFeatured: false,
    images: [
      {
        path: "/projects/Individual-Development/Appreciative-Inquiry-The-Power-Of-Gratitude/power-of-gratitude2.jpg",
        aspect: "16/9"
      },
      {
        path: "/projects/Individual-Development/Appreciative-Inquiry-The-Power-Of-Gratitude/power-of-gratitude3.jpg",
        aspect: "16/9"
      },
      {
        path: "/projects/Individual-Development/Appreciative-Inquiry-The-Power-Of-Gratitude/power-of-gratitude4.jpg",
        aspect: "16/9"
      },
      {
        path: "/projects/Individual-Development/Appreciative-Inquiry-The-Power-Of-Gratitude/sell-it-smart1.jpg",
        aspect: "16/9"
      },
      {
        path: "/projects/Individual-Development/Appreciative-Inquiry-The-Power-Of-Gratitude/sell-it-smart2.jpg",
        aspect: "16/9"
      },
      {
        path: "/projects/Individual-Development/Appreciative-Inquiry-The-Power-Of-Gratitude/sell-it-smart3.jpg",
        aspect: "9/16"
      },
      {
        path: "/projects/Individual-Development/Appreciative-Inquiry-The-Power-Of-Gratitude/sell-it-smart4.jpg",
        aspect: "16/9"
      },
      {
        path: "/projects/Individual-Development/Appreciative-Inquiry-The-Power-Of-Gratitude/journalistic-writing1.jpg",
        aspect: "16/9"
      },
      {
        path: "/projects/Individual-Development/Appreciative-Inquiry-The-Power-Of-Gratitude/journalistic-writing2.jpg",
        aspect: "16/9"
      },
      {
        path: "/projects/Individual-Development/Appreciative-Inquiry-The-Power-Of-Gratitude/journalistic-writing3.jpg",
        aspect: "16/9"
      },
    ]
  },
]

export default IndividualDevelopmentProjects;